import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  root: {
    display: "flex",
    maxWidth: "100vw",
    overflowX: "hidden",
  },

  BrandLogoBackground: {
    background: theme.palette.background.paper,

  },
  content: {
    flexGrow: 1,
    // padding: 5,//theme.spacing(3),
    paddingTop: 0,
    width: `calc(100vw - 240px)`,
    minHeight: "100vh",
  },
  contentShift: {
    width: `calc(100vw - ${240 + theme.spacing(6)}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  // contentRightBar: {
  //   flexGrow: 1,
  //   padding: 5,//theme.spacing(3),
  //   width: `calc(100vw - 240px)`,
  //   minHeight: "100vh",
  // },
  // contentShiftRightBar: {
  //   width: `calc(100vw - ${240 + theme.spacing(6)}px)`,
  //   transition: theme.transitions.create(["width", "margin"], {
  //     easing: theme.transitions.easing.sharp,
  //     duration: theme.transitions.duration.enteringScreen,
  //   }),
  // },


  // contentRightBar: {
  //   flexGrow: 1,
  //   // padding: theme.spacing(3),
  //   transition: theme.transitions.create('margin', {
  //     easing: theme.transitions.easing.sharp,
  //     duration: theme.transitions.duration.leavingScreen,
  //   }),
  //   marginRight: -60,
  // },
  // contentShiftRightBar: {
  //   transition: theme.transitions.create('margin', {
  //     easing: theme.transitions.easing.easeOut,
  //     duration: theme.transitions.duration.enteringScreen,
  //   }),
  //   marginRight: -60,
  // },

  fakeToolbar: {
    //minHeight: 40,   //...theme.mixins.toolbar,
  },
  BrandLogoBar: {
    // backgroundColor: theme.palette.background.paper,
  },
  themeIcon: {
    position: 'fixed',
    top: 0,
    right: 200,
    color: "white",
    padding: "5px",
    width: "30px",
    height: "35px",
    zIndex: 3000,
    backgroundColor: theme.palette.secondary.main,
    borderBottomRightRadius: 30,
    borderBottomLeftRadius: 30,
    transition: "0.2s width",
    '&:hover': {
      cursor: "pointer",
      height: "50px"
    },
  },
}));
